<script setup lang="ts">
/**
 * Paso de pago en vivo: abre el Brick de MercadoPago sobre el chat.
 *
 * No hay campos de tarjeta aquí a propósito. Los captura MercadoPago en sus
 * propios iframes, fuera del Shadow DOM del widget — el número de tarjeta no
 * toca nuestro código en ningún momento.
 */
import { ref } from 'vue'
import { openCardBrick, type PaidPayload } from '@/payments'

const props = defineProps<{ amount: number; currency: string; email?: string }>()
const emit = defineEmits<{ (e: 'paid', payload: PaidPayload): void }>()

const abriendo = ref(false)
const error = ref('')

function money(n: number, c: string): string {
  return new Intl.NumberFormat('es-MX', { style: 'currency', currency: c }).format(n)
}

async function abrir(): Promise<void> {
  if (abriendo.value) return
  abriendo.value = true
  error.value = ''
  try {
    const pago = await openCardBrick({
      amount: props.amount,
      currency: props.currency,
      email: props.email,
    })
    // null = cerró la capa sin pagar. No es un error: simplemente no seguimos.
    if (pago) emit('paid', pago)
  } catch (e) {
    error.value = e instanceof Error ? e.message : 'No se pudo abrir el pago seguro.'
  } finally {
    abriendo.value = false
  }
}
</script>

<template>
  <div class="bp">
    <button class="rm-btn wide" :disabled="abriendo" @click="abrir">
      {{ abriendo ? 'Abriendo…' : `Pagar ${money(props.amount, props.currency)}` }}
    </button>
    <div class="bp-msi">Aceptamos meses sin intereses con bancos participantes</div>
    <div v-if="error" class="bp-err">{{ error }}</div>
  </div>
</template>

<style scoped>
.bp-msi { margin-top: 7px; font-size: 11.5px; color: var(--tc-muted); text-align: center; }
.bp-err { margin-top: 7px; font-size: 12px; color: #b3261e; }
</style>
